import FadeUp from "../components/FadeUp";
import { COMPANY } from "../lib/constants";

const LAST_UPDATED = "June 2026";

export default function Terms() {
    return (
        <main
            className="min-h-screen bg-[#050505] text-white pt-28 md:pt-32"
            data-testid="terms-page"
        >
            <section className="container-bevel section-pad max-w-4xl">
                <FadeUp>
                    <span className="overline">Legal</span>
                    <h1 className="font-display text-4xl md:text-6xl mt-4 leading-[1.05]">
                        Terms of Use
                    </h1>
                    <p className="mt-6 text-sm uppercase tracking-[0.22em] text-white/50">
                        Last Updated: {LAST_UPDATED}
                    </p>
                </FadeUp>

                <FadeUp delay={1}>
                    <div className="mt-14 space-y-10 text-white/80 leading-relaxed">
                        <section>
                            <p>
                                Welcome to {COMPANY.name}&apos;s website. By
                                accessing or using{" "}
                                <span className="text-white">
                                    bevelcommercial.com
                                </span>
                                , you agree to the following terms. If you do
                                not agree, please do not use the site.
                            </p>
                        </section>

                        <section>
                            <h2 className="font-display text-2xl md:text-3xl text-white">
                                1. Informational Use Only
                            </h2>
                            <p className="mt-4">
                                The content on this website is provided for
                                general informational purposes about Bevel
                                Commercial Services and our construction and
                                renovation capabilities. It is not an offer,
                                proposal, or contract to perform work. All
                                projects are governed by a separate written
                                agreement signed by both parties.
                            </p>
                        </section>

                        <section>
                            <h2 className="font-display text-2xl md:text-3xl text-white">
                                2. Project Estimates &amp; Timelines
                            </h2>
                            <p className="mt-4">
                                Any pricing ranges, package timelines, or
                                project duration references on this site
                                (including the Renovation Packages page) are
                                illustrative and typical. Actual pricing and
                                schedules depend on scope, site conditions,
                                permitting, material availability, and other
                                project-specific factors, and will be
                                confirmed in a written proposal before any
                                work begins.
                            </p>
                        </section>

                        <section>
                            <h2 className="font-display text-2xl md:text-3xl text-white">
                                3. ROI &amp; Resale References
                            </h2>
                            <p className="mt-4">
                                Statements referring to return on investment,
                                resale value, or financial outcomes describe
                                our general design philosophy and the way we
                                scope projects. They are not a guarantee of
                                any specific financial result. Property value,
                                sale price, and market timing are determined
                                by market conditions and factors outside our
                                control.
                            </p>
                        </section>

                        <section>
                            <h2 className="font-display text-2xl md:text-3xl text-white">
                                4. Imagery &amp; Portfolio
                            </h2>
                            <p className="mt-4">
                                Featured before/after transformations and
                                photographs identified as Bevel projects
                                represent work completed by our team or by
                                partners we have managed. Certain gallery
                                sections and category illustrations may use
                                stock or representative photography, and are
                                labelled as such. Representative imagery is
                                included to communicate the type and quality
                                of work we deliver, not to depict a specific
                                Bevel project.
                            </p>
                        </section>

                        <section>
                            <h2 className="font-display text-2xl md:text-3xl text-white">
                                5. Licensing &amp; Insurance
                            </h2>
                            <p className="mt-4">
                                Bevel Commercial Services operates as a
                                licensed and insured general contractor in
                                the State of Oklahoma. Current license,
                                insurance, and bonding information is
                                available on request by contacting us at{" "}
                                <a
                                    href={COMPANY.emailHref}
                                    className="text-[#F5A623] underline underline-offset-4 hover:text-[#ffb94a]"
                                >
                                    {COMPANY.email}
                                </a>
                                .
                            </p>
                        </section>

                        <section>
                            <h2 className="font-display text-2xl md:text-3xl text-white">
                                6. Intellectual Property
                            </h2>
                            <p className="mt-4">
                                The Bevel name, logo, written content,
                                photography of our completed projects, and
                                the overall design of this website are the
                                property of {COMPANY.name} and may not be
                                reproduced, redistributed, or used without
                                prior written permission.
                            </p>
                        </section>

                        <section>
                            <h2 className="font-display text-2xl md:text-3xl text-white">
                                7. Third-Party Links
                            </h2>
                            <p className="mt-4">
                                This site may link to third-party resources
                                for your convenience. We do not control and
                                are not responsible for the content,
                                availability, or privacy practices of those
                                external sites.
                            </p>
                        </section>

                        <section>
                            <h2 className="font-display text-2xl md:text-3xl text-white">
                                8. Disclaimer of Warranties
                            </h2>
                            <p className="mt-4">
                                This website is provided &ldquo;as is&rdquo;
                                without warranties of any kind, express or
                                implied. We make reasonable efforts to keep
                                information accurate and up to date but do
                                not warrant that the site will be
                                error-free, uninterrupted, or free of
                                harmful components.
                            </p>
                        </section>

                        <section>
                            <h2 className="font-display text-2xl md:text-3xl text-white">
                                9. Limitation of Liability
                            </h2>
                            <p className="mt-4">
                                To the maximum extent permitted by law,{" "}
                                {COMPANY.name} is not liable for any
                                indirect, incidental, consequential, or
                                punitive damages arising out of your use of,
                                or inability to use, this website. Our total
                                liability for any claim arising from your use
                                of this website will not exceed one hundred
                                US dollars (USD $100).
                            </p>
                        </section>

                        <section>
                            <h2 className="font-display text-2xl md:text-3xl text-white">
                                10. Governing Law
                            </h2>
                            <p className="mt-4">
                                These Terms are governed by the laws of the
                                State of Oklahoma, without regard to its
                                conflict-of-law rules. Any dispute arising
                                from your use of this website will be
                                resolved in the state or federal courts
                                located in Tulsa County, Oklahoma.
                            </p>
                        </section>

                        <section>
                            <h2 className="font-display text-2xl md:text-3xl text-white">
                                11. Changes to These Terms
                            </h2>
                            <p className="mt-4">
                                We may update these Terms from time to time.
                                The &ldquo;Last Updated&rdquo; date reflects
                                the most recent revision. Continued use of
                                the site after an update constitutes your
                                acceptance of the revised Terms.
                            </p>
                        </section>

                        <section>
                            <h2 className="font-display text-2xl md:text-3xl text-white">
                                12. Contact
                            </h2>
                            <p className="mt-4">
                                Questions about these Terms can be sent to:
                            </p>
                            <div className="mt-5 border border-white/10 bg-[#0A0A0A] p-6">
                                <div className="text-white font-display text-lg">
                                    {COMPANY.name}
                                </div>
                                <div className="mt-2 text-white/75 text-sm">
                                    {COMPANY.address}
                                </div>
                                <div className="mt-2 text-sm">
                                    <a
                                        href={COMPANY.emailHref}
                                        className="text-[#F5A623] underline underline-offset-4 hover:text-[#ffb94a]"
                                    >
                                        {COMPANY.email}
                                    </a>
                                </div>
                                <div className="mt-1 text-sm">
                                    <a
                                        href={COMPANY.phoneHref}
                                        className="text-white/80 hover:text-white"
                                    >
                                        {COMPANY.phone}
                                    </a>
                                </div>
                            </div>
                        </section>
                    </div>
                </FadeUp>
            </section>
        </main>
    );
}
